import React, { useState, useEffect } from 'react';
import { 
  Modal, 
  Form, 
  Select, 
  message, 
  Row, 
  Col 
} from "antd";
import { platformApi } from '../../../../api';

const { Option } = Select;

const ChangeOrderStatusFixed = ({ open, close, reloadData, form, chassis = '' }) => {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  const [loading, setLoading] = useState(false);
  const [regOptions, setRegOptions] = useState([]);
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    if (open) {
      setFieldsValue({
        status: "RECEIVED",
        registrationNumbers: []
      });
      fetchRegistrationNumbers("RECEIVED", chassis);
    }
  }, [open]);

  const fetchRegistrationNumbers = (status, search = "") => {
    setFetching(true);
    platformApi.post(`/api/numberplate/get`, {
      status,
      searchString: search
    })
      .then((res) => {
        const options = res.data.data.numberPlates.map(obj => ({
          value: obj.registerNo,
          label: obj.registerNo
        }));
        setRegOptions(options);

        // ✅ If chassis is provided, auto-select and disable field
        if (chassis && options.length > 0) {
          const match = options.find(opt => opt.value === chassis);
          setFieldsValue({
            registrationNumbers: match ? match.value : options[0].value
          });
        }
      })
      .catch(() => {
        message.error("Failed to fetch registration numbers");
      })
      .finally(() => {
        setFetching(false);
      });
  };

  const handleSearch = (value) => {
    if (!chassis) {
      fetchRegistrationNumbers(
        getFieldValue('status') || "RECEIVED", 
        value
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        setLoading(true);
        const endpoint = "/api/numberplate/status/fixed";
        
        platformApi.post(endpoint, {
          registerNo: values.registrationNumbers
        })
          .then(() => {
            message.success(`Status changed to fixed successfully`);
            close();
            reloadData();
          })
          .catch(() => {
            message.error("Failed to update status");
          })
          .finally(() => {
            setLoading(false);
          });
      }
    });
  };

  return (
    <Modal
      width="40%"
      title="Update Fixed Number Plates"
      visible={open}
      onCancel={close}
      onOk={handleSubmit}
      confirmLoading={loading}
      okText="Update to Fixed"
    >
      <Form onSubmit={handleSubmit}>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Registration Number">
              {getFieldDecorator('registrationNumbers', {
                rules: [{ required: true, message: 'Please select a registration number' }]
              })(
                <Select
                  placeholder="Select registration number"
                  loading={fetching}
                  filterOption={false}
                  onSearch={handleSearch}
                  showSearch
                  allowClear={!chassis}
                  disabled={!!chassis}
                >
                  {regOptions.map(option => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default Form.create()(ChangeOrderStatusFixed);